/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessLevel = {
  FULL: "FULL",
  EDIT: "EDIT",
  READ: "READ",
  CREATE: "CREATE",
  RELEASE: "RELEASE",
  NONE: "NONE",
} as const;
